// Date row shown on Document Library cards (ProviderDetailCard).
// VQA (Audit): Assessment Date, "TBD" when unknown.
// VQQ (RFI): Publish Date when Published/Released, otherwise Request Date; blank when missing.
// The backend coalesces request/publish dates from the per-sponsor rows, so a blank here means
// the date is genuinely unknown; never render a fake placeholder date.
export const getDocumentCardDate = ({
  documentType,
  status,
  publishedDate,
  requestedDate,
  assessmentDate,
}) => {
  const isVqaDocument = documentType?.toLowerCase() === "vqa";
  const isPublishedOrReleased = status === "Released" || status === "Published";

  const label = isVqaDocument
    ? "Assessment Date"
    : isPublishedOrReleased
    ? "Publish Date"
    : "Request Date";

  const rawValue = isVqaDocument
    ? assessmentDate
    : isPublishedOrReleased
    ? publishedDate
    : requestedDate;

  const hasValue = rawValue !== null && rawValue !== undefined && rawValue !== "";

  return {
    label,
    value: hasValue ? rawValue : null,
    fallback: isVqaDocument ? "TBD" : "",
  };
};
